// extracted by mini-css-extract-plugin
export default {"viewBtn":"PrintLink_viewBtn__ozChG","spin":"PrintLink_spin__Wefcp"};